<template>
  <div class="ksm-sidebar__wrapper" :key="'siderbar'+modusOption.key">
    <div class="ksm-sidebar__container" :style="sidebarPageStyle">
      <template v-for="(it,i) in accordionList">
        <div
          class="ksm-accordion__header"
          :key="'t'+i"
          :style="i==0?'border-top-color:transparent':''"
        >
          <div
            v-if="modusOption.key!=='ansicht' && modusOption.key!=='komposition'"
            style="width:22px; height:100%; padding:3px"
            @click="selectItem(it.id)"
            v-html="!showArrow?'':$_getIcon(openedAccordionId===it.id?'arrow-down.svg':'arrow-right.svg')"
          ></div>
          <!-- <div v-else style="width:40px"></div> -->
          <div
            class="ksm-flex-1 ksm-flex"
            :style="(modusOption.key==='ansicht' || modusOption.key==='komposition')?'margin-left:10px':''"
            style="align-items: center"
            @click="selectItem(it.id)"
          >{{it.label}}</div>
          <div
            v-if="it.transcriptButtonEnable || it.kategorieButtonEnable"
            class="ksm-accordion__header-tool"
            :class="it.id"
          >
            <div
              v-if="it.transcriptButtonEnable"
              style="width:40px;"
              @click="it.transcriptButtonChecked=!it.transcriptButtonChecked"
              class="ksm-accordion__svg-btn"
              :class="it.transcriptButtonChecked?'__aktiv':'inaktiv'"
              v-html="it.transcriptButtonChecked?$_getSvg('transkriptionen-aktiv.svg'):$_getSvg('transkriptionen-inaktiv.svg')"
            ></div>
            <div
              v-if="it.kategorieButtonEnable"
              style="width:20px;"
              @click="it.kategorieButtonChecked=!it.kategorieButtonChecked"
              class="ksm-accordion__svg-btn"
              :class="it.kategorieButtonChecked?'__aktiv':'inaktiv'"
              v-html="it.kategorieButtonChecked?$_getSvg('relationen-aktiv.svg'):$_getSvg('relationen-inaktiv.svg')"
            ></div>
          </div>
        </div>
        <div
          class="ksm-accordion__body"
          @click="handleMouseclick"
          @mouseover="handleMouseover"
          @mouseout="handleMouseout"
          :class="openedAccordionId===it.id?('ksm-accordion__expand '+modusOption.key+'smodus'):'ksm-accordion__collapse '+modusOption.key+'smodus'"
          :key="'b'+i"
        >
          <div class="ksm-accordion__content">
            <!-- Kommentar -->
            <div v-if="it.id=='acco_kommentar'" style="padding-bottom:10px">
              <div
                class="ksm-accordion__section"
                v-for="(mk,mki) in mainKommentar"
                :key="mki"
                v-html="mk"
              ></div>
            </div>

            <!-- acco_uebersetzung, acco_relation  -->
            <div
              style="padding:10px 0px;"
              v-if="['acco_uebersetzung','acco_relation'].indexOf(it.id)>-1 && noteHtmlData"
            >
              <div v-for="(n,j) in noteHtmlData[it.id]" :key="j" v-html="n"></div>
            </div>
            <!-- acco_einzelstellenkommentare  -->
            <div v-if="it.id==='acco_einzelstellenkommentare' && noteHtmlData">
              <div v-for="(n,j) in noteHtmlData[it.id]" :key="j" v-html="n"></div>
            </div>
            <!-- acco_elementebibliothek -->
            <div v-if="it.id==='acco_elementebibliothek'" class="ksm-flex" style="flex-wrap:wrap">
              <div
                v-for="(obj, oi) of cropImageList"
                :key="'o'+oi"
                style="padding:5px; width:100px; height:100px; border:1px solid #fff; margin:5px"
                class="ksm-flex-xy-center"
                :data-acco="it.id+'#'+obj.id"
                :data-transcript="[obj.id]"
              >
                <img
                  :data-trid="obj.id"
                  draggable="true"
                  @dragstart="imgDragStart"
                  @dragend="imgDragEnd"
                  style="max-width:100%; max-height:100%"
                  :src="obj.src"
                />
              </div>
            </div>
            <!-- acco_personen -->
            <div v-if="it.id=='acco_personen'">
              <div v-for="(p,pi) of personen" :key="pi" style="margin:5px 10px">
                <div class="ksm-flex-y-center" :data-pid="p.lemmaID">
                  <div
                    class="div-with-transcript"
                    :data-acco="it.id+'#'+p.lemmaID"
                    :data-transcript="p.transcripts.join(',')"
                  >{{p.content}}</div>
                  <div style="margin:0 0.2em">({{p.docIds.length}})</div>
                  <div
                    class="ksm-user-circle"
                    v-html="$_getSvg('id-card.svg')"
                    @click="gotoPerson(p)"
                  ></div>
                  <div
                    class="ksm-user-arrow"
                    @click="togglePersonItem(p.lemmaID)"
                    v-html="$_getIcon(isAccoPersonExpand(p.lemmaID)?'arrow-down.svg':'arrow-right.svg')"
                  ></div>
                </div>
                <div
                  class="ksm-accordion__body"
                  :class="isAccoPersonExpand(p.lemmaID)?'':'ksm-accordion__collapse'"
                  style="border-width:0; padding:0 10px"
                >
                  <g-person-merz
                    style="font-size:10pt; padding-left:15px;"
                    :modusOption="modusOption"
                    :person="p"
                  ></g-person-merz>
                </div>
              </div>
            </div>
            <!-- acco_inventarisierung -->
            <div v-if="it.id=='acco_inventarisierung'">
              <div
                v-for="(inv, j) of acco_inventarisierung"
                :key="j"
                style="padding:5px"
                :style="j>0?'border-top:1px solid #fff':''"
              >
                <div
                  v-for="(inv_d, j_d) of inv.data"
                  :key="j_d"
                  style="margin:5px 0;"
                ><span style=" font-weight:bold">{{inv_d.label}}</span>: {{inv_d.value}}</div>
              </div>
            </div>
                        <!-- acco_transkription -->
            <div v-if="it.id=='acco_transkription'">
              <div style="padding:5px" >
              <div v-for="(n,j) in seite.$_docInfo" :key="j" v-html="n._source['98_html']"></div>
              </div>
            </div>
            <!-- Orte und Wege -->
            <div v-if="it.id=='acco_orte'" class="ksm-texte__modus-main" style>
              <div
                v-for="(ort, oi) of orte"
                :key="oi"
                class="div-with-transcript ksm-flex-y-center"
                style="margin:5px 10px"
                :data-acco="it.id+'#'+ort.ID"
                :data-transcript="ort.transcripts.join(',')"
              >{{ort.content}}</div>
              <template v-if="openedAccordionId==='acco_orte'">
                <MapView
                  v-if="ortGeoData"
                  :geoData="ortGeoData"
                  @inited="mapInited"
                  :option="{hideTimeline:true, zoom:3}"
                ></MapView>
              </template>
            </div>
            <!-- accor_themen -->
            <div v-if="it.id=='acco_themen'">
              <div style="padding:5px" v-for="(th,j) in themen" :key="j">
                <div
                  class="div-with-transcript ksm-flex-y-center"
                  :class="th.class+'-hover'"
                  :data-acco="it.id+'#'+th.info.ID"
                  :data-transcript="th.transcripts.join(',')"
                  @click="th.checked=!th.checked"
                >
                  <div
                    :class="th.checked?th.class:''"
                    style="width:15px; height:15px; margin-right:5px; border:1px solid #000"
                  ></div>
                  {{th.info.content}}
                </div>
              </div>
            </div>
            <!-- Seitenvorschau -->
            <template v-if="it.id=='acco_seitenvorschau'">
              <Thumbnail
                @selectItem="selectThumbnail"
                :seiten="seiten"
                :seiteIdx="seiteIdx"
                :aligen="'vertical'"
              ></Thumbnail>
            </template>

            <div v-if="it.id!='acco_orte'" style="height:100px"></div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Thumbnail from "comps/Thumbnail";
import MapView from "comps/MapView.vue";

export default {
  components: { Thumbnail, MapView },
  props: {
    merz: Object,
    seiteIdx: Number,
    sidebarPageStyle: String,
    modusOption: Object
  },

  data() {
    return {
      transcriptOverlayers: [],
      needReloadCropImages: true,
      stopFetchCropImg: false,
      cropImageList: [],
      geoData: null,
      map: null
    };
  },

  watch: {
    fetchSeiteDataDone(a) {
      this.cropImageList = [];
      if (a && this.needReloadCropImages) {
        this.drawCropImages();
      }
    },
    seite(a) {
      this.stopFetchCropImg = true;
      this.cropImageList = [];
      if (!this.fetchSeiteDataDone) {
        this.needReloadCropImages = true;
      } else if (this.needReloadCropImages) {
        this.needReloadCropImages = false;
        this.drawCropImages();
      }
      // this.scrollToPersonById();
    }
  },
  created: function() {
    this.$store.dispatch("orteundwege/fetchGeoData", this).then(res => {
      this.geoData = res;
    });
  },
  methods: {
    gotoPerson(person) {
      this.$router.push({
        path: "/personen",
        query: {
          lemmaID: person.lemmaID
        }
      });
    },
    scrollToPersonById() {
      const vue = this;
      const ids = this.accoExpandPersonList;
      if (ids && ids.length > 0) {
        this.selectItem("acco_personen");
        const elem = this.$el.querySelector(
          "[data-pid='" + ids[ids.length - 1].perId + "'"
        );
        if (elem) {
          setTimeout(function() {
            elem.scrollIntoView({ behavior: "smooth" });
            const trElem = elem.querySelector("[data-transcript]");
            if (trElem) {
              const transcriptIds = trElem.getAttribute("data-transcript");
              if (transcriptIds) {
                const opt = vue.modusOption;
                vue.$store.state.eventBus.$emit(
                  ["mouseclick.sidebar", opt.viewKey, opt.key].join("-"),
                  transcriptIds
                );
              }
            }
          }, 2000);
        }
      }
    },

    async forEachFetchtranscriptCropImg(tag, seite, partTranscripts) {
      const cropImageList = this.cropImageList;
      for (let i = 0, tr, trID, l = partTranscripts.length; i < l; i++) {
        tr = partTranscripts[i];
        trID = tr.id;
        if (this.stopFetchCropImg) {
          return;
        }
        let base64 = seite._.cropImages[tr.id];
        if (!base64) {
          let res = await this.$store.dispatch("fetchtranscriptCropImg", {
            id: trID,
            tag: tag
          });
          base64 = "data:Image/png;base64," + res;
          seite._.cropImages[tr.id] = base64;
        }
        cropImageList.push({
          text: tr.text,
          id: trID,
          src: base64
        });
      }
      if (!seite._.fetchCropImagesEnd) {
        seite._.fetchCropImagesEnd = true;
      }
    },

    isAccoPersonExpand(perId) {
      return (
        this.accoExpandPersonList &&
        this.accoExpandPersonList.find(
          p =>
            p.perId === perId &&
            p.merzId === this.merz.id &&
            p.seiteIdx - this.seiteIdx === 0
        )
      );
    },
    togglePersonItem(i) {
      this.$store.commit("updateAccoPersonList", {
        modusOption: this.modusOption,
        perId: i,
        merzId: this.merz.id,
        seiteIdx: this.seiteIdx
      });
    },

    mapInited(map) {
      this.map = map;
      setTimeout(function() {
        map.updateSize();
      }, 300);
    },

    drawCropImages() {
      this.stopFetchCropImg = false;
      let seite = this.seite;
      const graphElemente = this.graphElemente;
      if (!graphElemente) {
        return;
      }
      const _allTranscripts = seite.$_allTranscripts;
      seite.$_attachmentTags.forEach(at => {
        const docID = parseInt(at.docID, 10);
        const ids = graphElemente[docID];
        if (ids) {
          const seiteTrans = _allTranscripts.find(d => d.docID - docID === 0);
          this.forEachFetchtranscriptCropImg(
            at.tag,
            seite,
            seiteTrans.transcripts.filter(tr => ids.indexOf(tr.id) > -1)
          );
        }
      });
    },

    // drawCropImages_bak() {
    //   this.stopFetchCropImg = false;
    //   let seite = this.seite;
    //   const transcriptMap = this.transcriptMap;
    //   if (!transcriptMap) {
    //     return;
    //   }

    //   seite.$_attachmentTags.forEach(at => {
    //     const part = transcriptMap.find(part => {
    //       return parseInt(part.docID, 10) === parseInt(at.docID, 10);
    //     });
    //     if (part) {
    //       this.forEachFetchtranscriptCropImg(at.tag, seite, part.transcripts);
    //     }
    //   });
    // },
    selectItem(id) {
      this.$store.dispatch("modus/updateModusOption", {
        modusOption: this.modusOption,
        key: this.modusOption.key + "/openedAccordionId",
        val: id
      });
    },

    selectThumbnail(i) {
      this.$emit("changeSeite", i);
    },

    //mouseover
    handleMouseover(e) {
      if (this.modusOption.key === "ansicht") {
        return;
      }

      let target = e.target;
      let vue = this;
      let transcriptIds;
      while (
        target.parentNode &&
        !target.classList.contains("ksm-accordion__body")
      ) {
        transcriptIds = target.getAttribute("data-transcript");
        if (transcriptIds) {
          break;
        } else {
          target = target.parentNode;
        }
      }

      transcriptIds = transcriptIds ? transcriptIds.split(",") : [];
      const opt = this.modusOption;
      this.$store.state.eventBus.$emit(
        ["mouseover.sidebar", opt.viewKey, opt.key].join("-"),
        transcriptIds
      );
    },

    //mouseout
    handleMouseout(e) {
      const opt = this.modusOption;
      this.$store.state.eventBus.$emit(
        ["mouseover.sidebar", opt.viewKey, opt.key].join("-"),
        []
      );
    },

    handleMouseclick(e) {
      const section = e.target;
      let transcriptIds = section.getAttribute("data-transcript");
      if (transcriptIds) {
        const opt = this.modusOption;
        this.$store.state.eventBus.$emit(
          ["mouseclick.sidebar", opt.viewKey, opt.key].join("-"),
          transcriptIds
        );
      }
    },

    getAccordionHtml(accordion) {
      const out = [];
      const merz = this.merz;
      const seite = this.seite;
      const fudkeys = accordion.fudkeys;
      const modus = this.modusOption.key;

      this.seite.$_docInfo.forEach(doc => {
        const notes = doc._source.notes;
        if (!notes) {
          return;
        }

        notes
          .filter(n => {
            return fudkeys.indexOf(n.category) > -1;
          })
          .forEach(n => {
            let cat = n.category;
            if (cat == "Übersetzung" && n.html.indexOf("dt.:") == 0) {
              n.html = n.html.substring(4);
            }
            let div = this.$_getNewHtmlElement(n.html, merz, doc, true);
            div.classList.add("ksm-accordion__section");
            div.setAttribute("data-acco", accordion.id + "#" + n.ID);
            let obj = seite.$_accoId_transcript_mapping[cat].find(c => {
              return c.ID === n.ID;
            });

            if (obj && obj.ids.length > 0) {
              div.setAttribute("data-transcript", obj.ids.join(","));
              modus === "ansicht"
                ? ""
                : div.classList.add("div-with-transcript");
            }
            out.push(div.outerHTML);
          });
      }); //foreach end

      return out;
    },

    //
    imgDragStart(e) {
      this.$emit("imgDragStart", e);
    },

    imgDragEnd(e) {
      this.$emit("imgDragEnd", e);
    }
  },

  //
  mounted() {
    const vue = this;
    this.$store.state.eventBus.$on(
      [
        "mouseover.transcripts",
        this.modusOption.viewKey,
        this.modusOption.key
      ].join("-"),
      function(data) {
        let data_acco_strings = [];
        data.forEach(acco => {
          data_acco_strings.push(acco.accoID + "#" + acco.accoItemIdx);
        });

        const divs = vue.$el.querySelectorAll("[data-acco]");
        if (divs) {
          divs.forEach(div => {
            if (data_acco_strings.indexOf(div.getAttribute("data-acco")) > -1) {
              div.classList.add("div-with-transcript-hover");
            } else {
              div.classList.remove("div-with-transcript-hover");
            }
          });
        }
      }
    );

    this.$store.state.eventBus.$on(
      [
        "mouseover.transcripts.komposition",
        this.modusOption.viewKey,
        this.modusOption.key
      ].join("-"),
      function(trs) {
        const divs = vue.$el.querySelectorAll("[data-acco]");
        let trID;
        if (trs && trs.length > 0) {
          trID = trs[0].id;
        }
        if (divs) {
          divs.forEach(div => {
            if (div.getAttribute("data-acco").indexOf(trID) > -1) {
              div.classList.add("div-with-transcript-hover");
            } else {
              div.classList.remove("div-with-transcript-hover");
            }
          });
        }
      }
    );

    this.$store.state.eventBus.$on(
      [
        "mouseclick.transcripts",
        this.modusOption.viewKey,
        this.modusOption.key
      ].join("-"),
      function(ids) {
        let div = vue.$el.querySelector(
          ".ksm-accordion__expand .div-with-transcript-hover"
        );
        if (div) {
          div.scrollIntoView({ behavior: "smooth" });
        }
      }
    );

    this.$store.state.eventBus.$on("dragStop", function() {
      if (vue.map) {
        vue.map.updateSize();
      }
    });

    if (this.needReloadCropImages) {
      this.needReloadCropImages = false;
      this.drawCropImages();
    }
    this.scrollToPersonById();
  },

  //
  computed: {
    ortGeoData() {
      if (!this.geoData || !this.orte) {
        return;
      }
      const idxs = this.orte.map(o => o.ID + "");
      const features = this.geoData.features.filter(
        f => idxs.indexOf(f.properties.stadtindex) > -1
      );
      return {
        features: features,
        type: "FeatureCollection"
      };
    },
    openedAccordionId() {
      return this.modusOption["openedAccordionId"];
    },

    accoExpandPersonList() {
      return this.modusOption.accoExpandPersonList;
    },

    showArrow() {
      if (
        this.modusOption.key === "ansicht" ||
        this.modusOption.key === "komposition"
      ) {
        return false;
      }

      return true;
    },

    accordionList() {
      const modusOption = this.modusOption;
      const list = modusOption.accordionList;
      let out;
      if (modusOption.urlparams.merzId === "Merz24") {
        out = list.filter(
          it =>
            [
              "acco_inventarisierung",
              "acco_kommentar",
              "acco_einzelstellenkommentare",
              "acco_personen",
              "acco_relation",
              "acco_themen"
            ].indexOf(it.id) > -1
        );
      } else if (modusOption.urlparams.merzId === "Merz10" || modusOption.urlparams.merzId === "Merz25") {
         out = list.filter(it => it.id !== "acco_themen");
      } else {
         out = list.filter(
          it =>
            [
              "acco_transkription",
              "acco_themen"
            ].indexOf(it.id) === -1
         );
      }

      if (
        out.length > 0 &&
        !out.find(o => o.id === modusOption.openedAccordionId)
      ) {
        modusOption.openedAccordionId = out[0].id;
      }
      return out;
    },

    graphElemente() {
      const seite = this.seite;
      if (!seite || !seite.$_graphElemente) {
        return;
      }
      return this.seite.$_graphElemente;
    },

    transcriptMap() {
      const seite = this.seite;
      if (!seite || !seite.$_accoId_transcript_mapping) {
        return;
      }

      const outMap = [];
      let idList = [];
      const map = seite.$_accoId_transcript_mapping;
      this.modusOption.accordionList.forEach(accordion => {
        accordion.fudkeys.forEach(k => {
          const arr = map[k];
          if (arr) {
            arr.forEach(ar => {
              idList = idList.concat(ar.ids);
            });
          }
        });
      });

      seite.$_allTranscripts.forEach(it => {
        const tmp = it.transcripts.filter(tr => {
          return idList.indexOf(tr.id) > -1;
        });
        outMap.push({
          docID: it.docID,
          transcripts: tmp
        });
      });

      return outMap;
    },

    seiten() {
      if (this.merz) {
        return this.merz.seiten;
      }
    },

    seite() {
      if (this.seiten && this.seiteIdx != undefined) {
        return this.seiten[this.seiteIdx];
      }
    },

    mainKommentar() {
      if (this.seite && this.seite.$_mainKommentar) {
        let res = [];
        this.seite.$_mainKommentar.forEach(mk => {
          let div = this.$_getNewHtmlElement(mk._source["114_html"], this.merz, mk, true);
          res.push(div.outerHTML);
        });
        return res;
      }
    },

    acco_inventarisierung() {
      return this.$store.getters["modus/getSeiteDataExtendInfo"](
        this.seite,
        "acco_inventarisierung",
        this.modusOption.viewKey
      );
    },

    noteHtmlData() {
      if (!this.seite || !this.seite.$_docInfo) {
        return;
      }
      const out = {};
      const getAccordionHtml = this.getAccordionHtml;
      this.modusOption.accordionList.forEach(fi => {
        out[fi.id] = getAccordionHtml(fi);
      });
      return out;
    },

    personen() {
      let pers = this.$store.getters["modus/getSeiteDataExtendInfo"](
        this.seite,
        "personen"
      );
      if (!pers) {
        return [];
      }
      // only persons on transcript
      pers = pers.filter(function(item) {
        return (item.transcripts.length > 0);
      });
      return pers;
    },

    orte() {
      let orte = this.$store.getters["modus/getSeiteDataExtendInfo"](
        this.seite,
        "orte"
      );
      if (!orte) {
        return;
      }
      // filter duplicates
      const seen = [];
      orte = orte.filter(function(item) {
        return seen.hasOwnProperty(item.ID) ? false : (seen[item.ID] = true);
      });
      return orte;
    },

    themen() {
      if (!this.seite) {
        return [];
      }

      if (this.seite.$_themen && this.seite.$_themen.length > 0) {
        return this.seite.$_themen;
      }

      const themen = this.$store.getters["modus/getSeiteDataExtendInfo"](
        this.seite,
        "themen"
      );
      this.seite.$_themen = themen ? themen : [];
      return this.seite.$_themen;
    },

    //  _cropImages() {
    //   if (this.seite) {
    //     //return this.seite.$_cropImages;
    //   }
    // },

    fetchSeiteDataDone() {
      const seite = this.seite;
      if (!seite || !seite.$_fetchAllExtendInfoEnd) {
        return;
      }
      this.needReloadCropImages = true;
      return true;
    }
  }
};
</script>

<style lang="scss">
[draggable] {
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  user-select: none;
  /* Required to make elements draggable in old WebKit */
  -khtml-user-drag: element;
  -webkit-user-drag: element;
  cursor: move;
}

.ksm-user-circle {
  margin: 0 0.2em;
  width: 16px;
  height: 16px;
  cursor: pointer;
  svg {
    * {
      fill: $blue1;
    }
  }
  &:hover {
    svg {
      * {
        fill: $untersuchung-color;
      }
    }
  }
}

.ksm-user-arrow {
  height: 20px;
  width: 20px;
  cursor: pointer;
  &:hover {
    svg {
      * {
        fill: $untersuchung-color;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// Sidebar.vue?3b189249